import { NUTRITION_FACTS_PANEL_SELECTOR } from "../util.js";

//////////////////////////////////////////
/// == Settings that we might tweak == ///
//////////////////////////////////////////

// 96 px/inch is a typical browser DPI.
// 72 px/inch is what Preview on Mac assumes; but at 72, the dimensions seem over-sized (if you interpret them as inches).
export const PX_PER_INCH = 96;

// The increments we agreed on were: 1/10, 1/8, 1/4, 1/3, 1/2; 1/8 covers both 1/4 and 1/2.
export const SNAP_TO_INCREMENTS = [0.1, 0.125, 1 / 3];

////////////////////////////
/// == DOM selectors == ///
///////////////////////////

/// Selectors related to measuring the label preview size:
export const RECIPE_TITLE = "#recipe-title";
export const LABEL_LOGO_WRAPPER = "#label-logo-wrapper";
export const NUTRITION_FACTS_PANEL = NUTRITION_FACTS_PANEL_SELECTOR; // Just the panel part.
export const BUSINESS_INFO_CONTAINER = "#manufacture-address";
export const BUSINESS_INFO_TEXTAREA = "#recipe_manufactured_at_growing_textarea textarea";
export const BIOENGINEERED = "#bioengineered-claim";
export const FACILITY_ALLERGEN_LIST = "#facility-allergen-list";
export const BARCODE_CONTAINER = "#barcode-container";
export const INGREDIENTS_AND_ALLERGENS = [
  [".agg-ingredient-list-recipe-name", ".agg-ingredient-list", ".agg-allergen-list"],
  ["#recipe-show-ingredient-list", "#allergen-list"],
  ["#new-canada-ingredients-allergens-table"],
];

/// Selectors related to re-triggering dimensions calculation:
// We currently watch the displayed slider sizes as one of the triggers for updating dimensions.
export const SLIDER_SIZE_1 = "#slider-size";
export const SLIDER_SIZE_2 = "#slider-size2";
// #label-and-claim-div is worth watching for resizes, but we can't measure it directly for accurate measurements.
export const LABEL_PREVIEW_CONTAINER = "#label-and-claim-div";

/// Selectors related to displaying the dimensions:
export const DIMENSIONS_NEAR_SLIDER = "#sidebar-preview-dimensions"; // singular element
export const CONTAINER_FOR_DIMENSIONS_NEAR_DOWNLOAD = ".download-preview-dimensions"; // multiple elements
export const DIMENSIONS_NEAR_DOWNLOAD = `${CONTAINER_FOR_DIMENSIONS_NEAR_DOWNLOAD} .dimensions-content`; // multiple elements
